import { useNavigate } from "react-router-dom";
import { getBaseRoute } from "@utils/route";
import { mapGradeCodeToGradeParamId } from "@/utils/routeUtil";
import { GRADE_STATUS } from "@/ts/enums/GradeStatus";
import { useUserSelector } from "@context/hooks";
import { isLearningDemoMode } from "@/demo/isLearningDemoMode";

export const useGoNoAccess = () => {
  const navigate = useNavigate();
  const { selectedGrade, headerDetails } = useUserSelector();
  const demoMode = isLearningDemoMode();

  return () => {
    if (demoMode) {
      const fallbackGrade =
        selectedGrade ??
        headerDetails.grades.find(
          grade => grade.status === GRADE_STATUS.CURRENT
        ) ??
        headerDetails.grades.find(
          grade => grade.status !== GRADE_STATUS.NOT_STARTED
        ) ??
        headerDetails.grades[0];

      const fallbackGradeParam = fallbackGrade
        ? mapGradeCodeToGradeParamId(fallbackGrade.grade_code)
        : undefined;

      if (fallbackGradeParam) {
        navigate(`${getBaseRoute()}${fallbackGradeParam}`, { replace: true });
        return;
      }
    }

    navigate(`${getBaseRoute()}no-access`, { replace: true });
  };
};
